/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        $("#nav-icon1").click(function () {
          $(this).toggleClass("open");
          $(".mobile-menu-overlay").slideToggle(100);
          // $('.blur-layer').toggleClass('blur');
        });

        /*
        $('#search-toggle').click(function(){
          $('.search-overlay').slideToggle(100);
        })
        */

        // searchToggle functionality in pure JS
        var searchToggle = document.getElementById("search-toggle");
        var searchOverlay = document.getElementById("search-overlay");

        searchToggle.addEventListener("click", function (event) {
          searchOverlay.style.display = "block";
        });

        $(".search-close").click(function () {
          $(".search-overlay").slideToggle(100);
        });

        $(".filter-toggle").click(function () {
          $(".sidebar-content").toggle();
          $(".filter-icon").toggleClass("open");
        });

        // triggers account icon drop-down
        /*$('#account-icon').mouseenter(function() {
          $('.account-dropdown-wrapper').toggleClass('account-dropdown-wrapper-open');
        });*/

        // triggers account icon drop-down closing
        /* $('#account-icon').mouseleave(function() {
          $('.account-dropdown-wrapper').toggleClass('account-dropdown-wrapper-open');
        }); */

        // triggers account icon drop-down closing
        /*$('.account-dropdown-wrapper').mouseleave(function() {
          $('.account-dropdown-wrapper').toggleClass('account-dropdown-wrapper-open');
        });*/
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        // retrieve latest blog news from wp-api
        $.ajax({
          url: "/wp-json/wp/v2/posts?categories=15",
          format: "json",
          success: function (data) {
            for (var i = 0; i < 4; i++) {
              var title = data[i].title.rendered;
              var url = data[i].link;
              var excerpt = data[i].excerpt.rendered;
              $(".post-" + i).append(
                '<h4 class="news-header"><a href="' +
                  url +
                  '">' +
                  title +
                  '</a></h4><span class="news-excerpt">' +
                  excerpt +
                  "</span>"
              );
            }
          }
        });
      }
    },
    // Product template page.
    product_template_default: {
      init: function () {
        // JavaScript to be fired on the product page
        $("#tab-description h5 span").css("color", "#3c1362");

        if ($('tr:contains("enrolment")').length) {
          $(".badge-wrapper-immediate").show();
        } else {
          $(".badge-wrapper-one-day").show();
        }

        // to hide notice about VAT and number of users that appears on many pages
        $(
          ".woocommerce-product-details__short-description > h5:contains('Price')"
        ).hide();
        $(
          ".woocommerce-product-details__short-description > h4:contains('Price')"
        ).hide();
        $(
          ".woocommerce-product-details__short-description > span:contains('Price')"
        ).hide();

        // JavaScript to be fired for currency converter modal
        // console.log('Currency yeah!');

        $("#convert-button").click(function () {
          var initialValue = $("input#initial-currency").val();
          var initialCurrency = $("#initial-currency-type").val();
          var targetCurrency = $("#target-currency-type").val();
          console.log(
            "Convert" +
              initialValue +
              "of" +
              initialCurrency +
              "to" +
              targetCurrency
          );

          $.ajax({
            url:
              "https://api.apilayer.com/exchangerates_data/latest?base=" +
              initialCurrency +
              "&symbols=" +
              targetCurrency,
            headers: {
              apikey: "WxVJJmC9YFIXBneXIG0rqnIM6h8ESFAV"
            },
            format: "json",
            success: function (data) {
              var currencyRate = data.rates;
              var exchangeRate = currencyRate[Object.keys(currencyRate)[0]];

              // console.log(exchangeRate);
              var convertedValue = exchangeRate * initialValue;
              var finalValue = convertedValue.toFixed(2);
              console.log(convertedValue);
              $("#conversion-result").empty();
              $("#conversion-result").append(
                initialValue +
                  " " +
                  initialCurrency +
                  " = " +
                  finalValue +
                  " " +
                  targetCurrency
              );
            }
          });
        });

        // controls showing of currency modal
        $(".currency-toggle").click(function () {
          $(".converter-hero-image").slideToggle(100);
          $(window).scrollTop(0);
        });

        $(".currency-close").click(function () {
          $(".converter-hero-image").slideToggle(100);
        });

        // handles switching plus/minus icon on product FAQs

        $(".collapse")
          .on("show.bs.collapse", function () {
            $(this)
              .parent()
              .find(".glyphicon-plus")
              .removeClass("glyphicon-plus")
              .addClass("glyphicon-minus");
          })
          .on("hide.bs.collapse", function () {
            $(this)
              .parent()
              .find(".glyphicon-minus")
              .removeClass("glyphicon-minus")
              .addClass("glyphicon-plus");
          });

        // Function to add 'Contact us' button to Core Learning 026 pages
        /*
        var microlearnProduct = $(".wcpv-sold-by-single").html();
        console.log(microlearnProduct);
        var productDescription = $(".product-summary-wrapper");

        if (
          microlearnProduct ==
          'Sold By: <a href="/vendor/core-learning-services-026/" title="Core Learning Services (026)">Core Learning Services (026)</a>'
        ) {
          console.log("Microlearn function");
          productDescription.append(
            '<a href="/contact-us/"><button class="single_add_to_cart_button button alt" style="margin-bottom: 40px; margin-top: 20px">Contact us for details</button></a>'
          );
        }
        */

        // check if a price excluding VAT is present and, if so, append 'including VAT' to main price
        if ($("#excluding-vat-price").length) {
          $(
            ".woocommerce div.product p.price, .woocommerce div.product span.price"
          ).append(" including VAT");
        }
      }
    },
    // News page
    news: {
      init: function () {
        // JavaScript to be fired on the news page

        // retrieve latest blog news from wp-api
        $.ajax({
          url: "/wp-json/wp/v2/posts?categories=15",
          format: "json",
          success: function (data) {
            for (var i = 0; i < 20; i++) {
              var title = data[i].title.rendered;
              var url = data[i].link;
              var excerpt = data[i].excerpt.rendered;
              $(".news-items").append(
                '<h4 class="news-header" style="padding-top: 20px"><a href="' +
                  url +
                  '">' +
                  title +
                  '</a></h4><span class="news-excerpt">' +
                  excerpt +
                  "</span>"
              );
            }
          }
        });
      }
    },
    // Product category page
    tax_product_cat: {
      init: function () {
        // JavaScript to be fired on the product category page
        // check if a price excluding VAT is present and, if so, append 'including VAT' to main price
        var products_to_append = $(".excluding-vat-price");
        // console.log(products_to_append);

        // loop over iterable object (not array) of products, retrieve ID and then append 'including VAT' to price
        products_to_append.each(function (i) {
          // retrieve ID from each product;
          var idToAppend = this.id;
          $(".post-" + idToAppend + " bdi")
            .last()
            .append(" including VAT");
        });
      }
    },
    // Search results
    search_results: {
      init: function () {
        // JavaScript to be fired on the product category page
        // check if a price excluding VAT is present and, if so, append 'including VAT' to main price
        var products_to_append = $(".excluding-vat-price");
        // console.log(products_to_append);

        // loop over iterable object (not array) of products, retrieve ID and then append 'including VAT' to price
        products_to_append.each(function (i) {
          // retrieve ID from each product;
          var idToAppend = this.id;
          $(".post-" + idToAppend + " bdi")
            .last()
            .append(" including VAT");
        });
      }
    },
    // All archive pages
    archive: {
      init: function () {
        // JavaScript to be fired on the archive pages
        // append 'archive' to the class 'woocommerce-products-header'
        $(".page-title").after(
          "<div class='grid-list-view' style='align-items: center'><p style='margin-bottom: 0px; padding-right: 5px'>Grid</p><label class='switch-ng'><input id='viewToggle' type='checkbox'><span class='slider-ng round-ng'></span></label><p style='margin-bottom: 0px; padding-left: 5px'>List</p></div>"
        );

        var body = document.querySelector("body");
        var toggle = document.querySelector("#viewToggle");

        // Set initial state of the toggle based on the body class
        /*
        if (window.innerWidth > 767) {
          if (body.classList.contains("list-view")) {
            toggle.checked = true;
            $("ul.products.columns-4").removeClass("products");
          } else {
            toggle.checked = false;
            $("ul.columns-4").addClass("products");
          }
        }
        */

        // check for cookie and set toggle accordingly. Modification of body class and ul class is now handled by PHP in functions.php and woocommerce > loop > loop-start.php
        if (window.innerWidth > 767) {
          var cookie = document.cookie;
          if (cookie.indexOf("view=list") >= 0) {
            toggle.checked = true;
            //$("ul.products.columns-4").removeClass("products");
            //body.classList.add("list-view");
          } else if (cookie.indexOf("view=grid") >= 0) {
            toggle.checked = false;
            //$("ul.columns-4").addClass("products");
            //body.classList.remove("list-view");
          }
        }

        // Listen for click event on the toggle
        toggle.addEventListener("click", function () {
          if (this.checked) {
            body.classList.add("list-view");
            $("ul.products.columns-4").removeClass("products");
            // set cookie to remember list view
            document.cookie =
              "view=list; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Lax; Secure";
          } else {
            body.classList.remove("list-view");
            $("ul.columns-4").addClass("products");
            // set cookie to remember grid view
            document.cookie =
              "view=grid; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Lax; Secure";
          }
        });

        // listen for screen resize and remove list view styling if screen is less than 767px
        $(window).resize(function () {
          if (window.innerWidth < 767) {
            if (body.classList.contains("list-view")) {
              toggle.checked = false;
              body.classList.remove("list-view");
              $("ul.columns-4").addClass("products");
            }
          }
        });

        // search/filter function
        var typingTimer;

        $("#product-search-box").on("keyup", function () {
          clearTimeout(typingTimer);
          typingTimer = setTimeout(sendRequest, 500);
        });

        $("#product-search-box").on("keydown", function () {
          clearTimeout(typingTimer);
        });

        function sendRequest() {
          // $("#product-search").append('<p class="loading">Searching...</p>');

          // add a message near the search box to indicate that the search is being performed
          console.log("Searching...");
          $.ajax({
            url: my_ajax_object.ajax_url,
            data: {
              action: "product_search",
              keyword: $("#product-search-box").val()
            },
            method: "POST",
            success: function (response) {
              // Replace the product loop with the returned data.
              $(".products").html(response);
            }
          });
        }
      }
    },
    // Vendor page
    tax_wcpv_product_vendors: {
      init: function () {
        // JavaScript to be fired on the vendor  page

        // vendor view is a list by default
        // var body = document.querySelector("body");
        // var toggle = document.querySelector("#viewToggle");
        // body.classList.add("list-view");
        // $("ul.products.columns-4").removeClass("products");
        // toggle.checked = true;

        // hide any elements with a data-parent value greater than 0
        $("li").each(function () {
          var hierarchyValue = $(this).attr("data-parent");
          if (hierarchyValue > 0) {
            $(this).hide();
          }
        });

        // check if a price excluding VAT is present and, if so, append 'including VAT' to main price
        var products_to_append = $(".excluding-vat-price");
        // console.log(products_to_append);

        // loop over iterable object (not array) of products, retrieve ID and then append 'including VAT' to price
        products_to_append.each(function (i) {
          // retrieve ID from each product;
          var idToAppend = this.id;
          $(".post-" + idToAppend + " bdi")
            .last()
            .append(" including VAT");
        });

        // if click on .wpfLiLabel scroll page to top
        $(".wpfLiLabel").click(function () {
          $(window).scrollTop(0);
        });
      }
    },
    // Hub page
    page_template_template_hub: {
      init: function () {
        // JavaScript to be fired on the Hub page

        // function triggered by scroll event
        $(window).scroll(function () {
          // tracks top position of window as scrolls
          var windowTop = $(window).scrollTop();

          // loops over each h2 and retrieves id and current top position
          $("h2").each(function (i) {
            var hubSection = $(this).attr("id");
            var hubSectionTop = $(this).offset().top;

            // if the top of the window is close to the top of the section remove the existing active class and add it to the jump nav link that has a href value matching the section id
            if (windowTop >= hubSectionTop - 20) {
              $(".jump-nav a .jump-nav-active").removeClass("jump-nav-active");

              // target p child of jump link that has href value that matches hubSection
              $("a[href$='" + hubSection + "'] p").addClass("jump-nav-active");
            }
          });
        });
      }
    },
    // News page
    page_template_template_currency: {
      init: function () {
        // JavaScript to be fired on the currency converter page
        // console.log('Currency yeah!');

        $("#convert-button").click(function () {
          var initialValue = $("input#initial-currency").val();
          var initialCurrency = $("#initial-currency-type").val();
          var targetCurrency = $("#target-currency-type").val();
          console.log(
            "Convert" +
              initialValue +
              "of" +
              initialCurrency +
              "to" +
              targetCurrency
          );

          $.ajax({
            url:
              "https://api.exchangeratesapi.io/latest?base=" +
              initialCurrency +
              "&symbols=" +
              targetCurrency,
            format: "json",
            success: function (data) {
              var currencyRate = data.rates;
              var exchangeRate = currencyRate[Object.keys(currencyRate)[0]];

              // console.log(exchangeRate);
              var convertedValue = exchangeRate * initialValue;
              var finalValue = convertedValue.toFixed(2);
              console.log(convertedValue);
              $("#conversion-result").empty();
              $("#conversion-result").append(
                initialValue +
                  " " +
                  initialCurrency +
                  " = " +
                  finalValue +
                  " " +
                  targetCurrency
              );
            }
          });
        });
      }
    },
    // checkout
    checkout: {
      init: function () {
        // JavaScript to be fired on the checkout page

        // logic to only show PO field if company name is entered
        var companyField = $("#billing_company");
        var poField = $("#po_field");

        // hide PO field on page load if company field is empty
        if (companyField.val().length === 0) {
          poField.hide();
        }

        // if company field is not empty show PO field
        companyField.blur(function () {
          if (companyField.val().length > 0) {
            poField.show();
          } else {
            poField.hide();
          }
        });

        // logic to ensure that Learnupon email addresses provided are unique. But fine for addresses not to be unique if used for different courses

        var values = [];

        var emailFields = $(
          ".learnupon_product_item_recipient > .email > .woocommerce-input-wrapper > input"
        );

        emailFields.blur(function () {
          // empty values array
          values = [];

          emailFields.each(function () {
            // console.log(emailFields);
            // Regular expression for validating email format
            var emailPattern =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            // Check if the email format is valid
            if (!emailPattern.test(this.value) && this.value.length > 0) {
              alert("ERROR. Please enter a valid email address.");
              return false; // <-- stops the loop
            }

            // check whether input value is present in array. Will return -1 if not in array, index position if is there
            if ($.inArray(this.value, values) >= 0 && this.value.length > 0) {
              // check whether id of value in array is same as id of one adding. If they are same throw error

              // check position of existing entry in array
              var indexPosition = $.inArray(this.value, values);

              // retrieve ID of existing field
              var existingID = emailFields[indexPosition].id;

              // remove variable text at end of id to allow comparison
              var reducedExistingID = existingID.slice(0, -8);
              var reducedNewID = this.id.slice(0, -8);

              /*
              console.log(
                "Latest ID = " +
                  reducedNewID +
                  " and original ID = " +
                  reducedExistingID
              );
              */

              // compare ids of two fields. If they are the same it is not possible to use the same email address for both and so throw error
              if (reducedNewID === reducedExistingID) {
                alert(
                  "ERROR. Email addresses for users on the same course must be unique. If you can't supply unique addresses please get in touch."
                );
              }

              return false; // <-- stops the loop
            }

            values.push(this.value);
          });
        });

        // logic to ensure that NON-Learnupon email addresses provided are unique. But fine for addresses not to be unique if used for different courses

        var nonLUvalues = [];

        var nonLUemailFields = $(
          ".nonluemail > .woocommerce-input-wrapper > input"
        );

        nonLUemailFields.blur(function () {
          // empty values array
          nonLUvalues = [];

          nonLUemailFields.each(function () {
            console.log(nonLUemailFields);

            var emailPattern =
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            // Check if the email format is valid
            if (!emailPattern.test(this.value) && this.value.length > 0) {
              alert("ERROR. Please enter a valid email address.");
              return false; // <-- stops the loop
            }

            // check whether input value is present in array. Will return -1 if not in array, index position if is there
            if (
              $.inArray(this.value, nonLUvalues) >= 0 &&
              this.value.length > 0
            ) {
              console.log("value is already in array");
              // check whether id of value in array is same as id of one adding. If they are same throw error

              // check position of existing entry in array
              var indexPosition = $.inArray(this.value, nonLUvalues);

              // retrieve ID of existing field
              var existingID = nonLUemailFields[indexPosition].id;
              console.log(existingID);

              // isolate product ID from string (numbers between two hyphens)
              var existingProductID = existingID.match(/-(\d+)-/)[1];
              console.log(existingProductID);
              // var reducedExistingID = existingID.slice(0, -8);
              var newProductID = this.id.match(/-(\d+)-/)[1];
              console.log(newProductID);

              /*
              console.log(
                "Latest ID = " +
                  reducedNewID +
                  " and original ID = " +
                  reducedExistingID
              );
              */

              // compare ids of two fields. If they are the same it is not possible to use the same email address for both and so throw error
              if (newProductID === existingProductID) {
                alert(
                  "ERROR. Email addresses for users on the same course must be unique. If you can't supply unique addresses please get in touch."
                );
              }

              return false; // <-- stops the loop
            }

            nonLUvalues.push(this.value);
            console.log(nonLUvalues);
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
